import { render, staticRenderFns } from "./SendIndicationsInfoPart.vue?vue&type=template&id=db0c1764&scoped=true&"
import script from "./SendIndicationsInfoPart.vue?vue&type=script&lang=js&"
export * from "./SendIndicationsInfoPart.vue?vue&type=script&lang=js&"
import style0 from "./SendIndicationsInfoPart.vue?vue&type=style&index=0&id=db0c1764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0c1764",
  null
  
)

export default component.exports